import React, { Component, PropTypes } from 'react';
import PageTitle from '../../PageTitle';

export default class NotFoundPage extends Component {
  render() {
    return (
      <PageTitle title="Page Not Found">
        <div>
          <div className="max-width">
            <h1 className="page-header">Error!</h1>
            <div key="a" className="alert alert-info">
              The URL entered was not found.
            </div>
          </div>
        </div>
      </PageTitle>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/NotFoundPage.jsx